export default function () {
    var make = function () {
        var lsatdel = '';
        var lsatdelpos = 0;

        var fff = function (val, that) {
            var VRegExp = new RegExp(/\D/g);
            var AInputText = val;
            var VResult = AInputText.replace(VRegExp, '');
            if (VResult.length == 0) {
                var VResult = '';
            } else if (VResult.length >= 1 && VResult.length < 4) {
                var fv = VResult.substr(0, 1);
                VResult = VResult.substr(1, 10);
                if (fv == 7 || fv == 8)
                    VResult = '7' + VResult;
                else
                    VResult = '7' + fv + VResult;
                var VRegExp = new RegExp(/^(\d)(\d{0,3})(\d{0,3})(\d{0,2})(\d{0,2})/g);
                var VResult1 = VResult.replace(VRegExp, '+$1 ($2');
            } else if (VResult.length >= 4 && VResult.length < 7) {
                var fv = VResult.substr(0, 1);
                VResult = VResult.substr(1, 10);
                if (fv == 7 || fv == 8)
                    VResult = '7' + VResult;
                else
                    VResult = '7' + fv + VResult;
                var VRegExp = new RegExp(/^(\d)(\d{0,3})(\d{0,3})(\d{0,2})(\d{0,2})/g);
                var VResult1 = VResult.replace(VRegExp, '+$1 ($2) $3');
            } else if (VResult.length >= 7 && VResult.length < 9) {
                var fv = VResult.substr(0, 1);
                VResult = VResult.substr(1, 10);
                if (fv == 7 || fv == 8)
                    VResult = '7' + VResult;
                else
                    VResult = '7' + fv + VResult;
                var VRegExp = new RegExp(/^(\d)(\d{0,3})(\d{0,3})(\d{0,2})(\d{0,2})/g);
                var VResult1 = VResult.replace(VRegExp, '+$1 ($2) $3-$4');
            } else if (VResult.length >= 9) {
                var fv = VResult.substr(0, 1);
                VResult = VResult.substr(1, 10);
                if (fv == 7 || fv == 8)
                    VResult = '7' + VResult;
                else
                    VResult = '7' + fv + VResult;
                var VRegExp = new RegExp(/^(\d)(\d{0,3})(\d{0,3})(\d{0,2})(\d{0,2})/g);
                var VResult1 = VResult.replace(VRegExp, '+$1 ($2) $3-$4-$5');
            }

            that.val(VResult1)[0].dispatchEvent(new Event('input'));
        }

        var delnumbp = function (that) {
            var VRegExp = new RegExp(/\D/g);
            var VResultTest = that.val().replace(VRegExp, '');
            if (VResultTest == '') {
                that.val('');
                return;
            }
            //debugger;
            var VRegExp = new RegExp(/^\d+$/);
            var VResult = VRegExp.test(lsatdel);
            var val = that.val();
            var valr = '';
            lsatdelpos -= 2;

            if (!VResult && lsatdelpos >= 0) {
                valr = val.substr(0, lsatdelpos);
                valr += val.substr(lsatdelpos + 1, 18);
                that.val(valr);
                lsatdel = val.substr(lsatdelpos, 1);
                lsatdelpos += 1;
                delnumbp(that);
            } else {
                fff(that.val(), that);
            }
            that[0].setSelectionRange(lsatdelpos + 1, lsatdelpos + 1);

        }

        var delnumdel = function (that) {
            var VRegExp = new RegExp(/\D/g);
            var VResultTest = that.val().replace(VRegExp, '');
            if (VResultTest == '') {
                that.val('');
                return;
            }
            var VRegExp = new RegExp(/^\d+$/);
            var VResult = VRegExp.test(lsatdel);
            var val = that.val();
            var valr = '';

            if (!VResult && lsatdelpos >= 0) {
                valr = val.substr(0, lsatdelpos);
                valr += val.substr(lsatdelpos + 1, 18);
                that.val(valr);
                lsatdel = val.substr(lsatdelpos, 1);
                if (lsatdel != '')
                    delnumdel(that);
            } else {
                fff(that.val(), that);
            }
            that[0].setSelectionRange(lsatdelpos, lsatdelpos);
        }

        // здесь переменная this будет содержать отдельный
        // DOM-элемент, к которому и нужно будет применить
        // воздействия плагина
        $(this).on('keydown', function (b) {
            if (b.keyCode == 8 || b.keyCode == 46) {
                if (b.keyCode == 8)
                    lsatdel = $(this).val().substr(this.selectionStart - 1, 1);
                else
                    lsatdel = $(this).val().substr(this.selectionStart, 1);
                lsatdelpos = this.selectionStart;
                //$(this).change();
                return true;
            }
        });
        $(this).on('keyup', function (b) {
            if (b.keyCode == 8) {
                delnumbp($(this));
            }
            if (b.keyCode == 46) {
                delnumdel($(this));
            }
        });
        $(this).on('keypress', function (b) {
            var VRegExp = new RegExp(/^\d+$/);
            var VResult = VRegExp.test(String.fromCharCode(b.which));
            if (VResult)
                fff($(this).val() + String.fromCharCode(b.which), $(this));
            return false;
        });

        $(this).change(function () {
            fff($(this).val(), $(this));
        });
    };

    return this.each(make);
};